module.exports = __webpack_public_path__ + "static/media/image9.751b5dc7.svg";